import { Button } from "@material-ui/core";
import React from "react";

type ToggleButtonProps = {
  value: boolean;
  onChange: (value: boolean) => void;
};

export const ToggleButton: React.FC<ToggleButtonProps> = ({
  value,
  onChange,
}) => {
  return value ? (
    <Button
      color="primary"
      onClick={() => onChange(false)}
      data-test="switch-to-selected-staff-button"
    >
      Switch to Selected Staff
    </Button>
  ) : (
    <Button
      color="primary"
      onClick={() => onChange(true)}
      data-test="switch-to-all-staff-button"
    >
      Switch to All Staff
    </Button>
  );
};
